export default "__VITE_ASSET__BCzg1Oud__"